import ReactTypingEffect from 'react-typing-effect';
import styled, { css } from 'styled-components';
import Heading from '../../../components/Atoms/Heading/Heading';
import Text from '../../../components/Atoms/Text/Text';
import InputText from '../../../components/Molecules/Inputs/InputText/InputText';
import { media } from '../../../theme/shared/breakpoints';
export const StyledWrapper = styled.div `
  flex: 1 0 auto;
  position: relative;
  z-index: ${({ isDropdownOpen }) => (isDropdownOpen ? 2 : 0)};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 15px;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  ${({ isDropdownOpen }) => !isDropdownOpen &&
    css `
      padding-top: 0;
    `};

  ${media.large} {
    padding: 0;
    background-color: unset;
  }
`;
export const StyledForm = styled.form `
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  margin: 0;

  & > div:first-child {
    z-index: 2;
  }

  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none !important;
  }
`;
export const StyledInputContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  visibility: ${({ isSearchBarVisible }) => (isSearchBarVisible ? 'visible' : 'hidden')};
  opacity: ${({ isSearchBarVisible }) => (isSearchBarVisible ? 1 : 0)};
  transition: opacity 0.3s ease, visibility 0.3s ease;

  & > div > div {
    background-color: ${({ theme }) => theme.colorsV2.ui.background.secondary};
    margin-bottom: 0; // remove styleguide margin
    border: 1px solid ${({ theme }) => theme.colorsV2.grayscale.black};
    box-sizing: border-box;
    border-radius: 20px;
    height: 40px;

    & > input {
      padding-left: 14px;

      &:focus::placeholder {
        visibility: hidden;
      }
    }

    &:focus-within {
      background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
    }
  }

  svg {
    width: 23px;
    height: auto;
  }
`;
export const StyledInputText = styled(InputText) `
  font-family: proxima-nova, Corbel, Arial, sans-serif;
`;
export const StyledReactTypingEffect = styled(ReactTypingEffect) `
  position: absolute;
  left: 12px;
  z-index: 3;
  padding: 7px 11px 7px 46px;
  font-size: 16px;
  line-height: 24px;
  pointer-events: none;

  ${media.large} {
    left: 2.5px;
  }
`;
export const StyledCancelIconWrapper = styled.div `
  position: absolute;
  right: 85px;
  top: 12px;
  display: ${({ isAutocompleteOpen }) => (isAutocompleteOpen ? 'flex' : 'none')};
  cursor: pointer;
  z-index: 2;
  visibility: ${({ isSearchBarVisible }) => (isSearchBarVisible ? 'visible' : 'hidden')};

  ${media.medium} {
    right: 16px;
    top: auto;
    display: flex;
  }
`;
export const StyledDropdownWrapper = styled.div `
  height: 100vh;
  width: 100vw;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  z-index: 1;
  position: relative;

  &::before {
    border-top: 1px solid ${({ theme }) => theme.colorsV2.ui.border.primary};
    content: '';
    height: 1px;
    position: absolute;
    left: 0;
    right: 0;
    top: 15px;
  }

  ${media.large} {
    padding: 50px 35px 15px;
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    border-radius: 8px;
    height: auto;
    min-height: 0;
    width: auto;
    z-index: 1;
    box-shadow: 2px 2px 6px rgb(0 0 0 / 20%);

    &::before {
      all: unset;
    }
  }
`;
export const StyledHeading = styled(Heading) `
  margin-top: ${({ hasRecentlySearchItems }) => (hasRecentlySearchItems ? '15px' : '10px')};
  margin-bottom: 15px;
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  ${({ hasRecentlySearchItems }) => hasRecentlySearchItems &&
    css `
      border-top: 1px solid ${({ theme }) => theme.colorsV2.ui.border.primary};
      padding-top: 15px;
    `}

  ${media.large} {
    border-top: unset;
    padding-top: unset;
    font-size: ${({ theme }) => theme.fontSizes.sizeMd2};
  }
`;
export const StyledCancelButton = styled(Text) `
  width: 50px;
  margin-left: 20px;
`;
export const StyledErrorText = styled(Text) `
  padding-top: 25px;
`;
//# sourceMappingURL=Autocomplete.styled.js.map